import React from 'react';
import { Link } from '@chakra-ui/react';

const URL_REGEX = /^(https?:\/\/[^\s]+)/;
const MAILTO_REGEX = /^(mailto:[^\s]+)/;
const EMAIL_REGEX = /^([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/;

/**
 * Convert a single word into a link element if it matches a URL, mailto, or email pattern.
 * Returns the word (with trailing space) if no match.
 */
const linkifyWord = (
  word: string,
  key: number | string,
  linkColor: string = 'cyan.300'
) => {
  if (URL_REGEX.test(word)) {
    return (
      <Link
        key={key}
        href={word}
        color={linkColor}
        target='_blank'
        rel='noopener noreferrer'
        textDecoration='underline'
      >
        {word}
      </Link>
    );
  }
  if (MAILTO_REGEX.test(word)) {
    return (
      <Link key={key} href={word} color={linkColor} textDecoration='underline'>
        {word}
      </Link>
    );
  }
  if (EMAIL_REGEX.test(word)) {
    return (
      <Link
        key={key}
        href={`mailto:${word}`}
        color={linkColor}
        textDecoration='underline'
      >
        {word}
      </Link>
    );
  }
  return word + ' ';
};

/**
 * Convert a string into React elements with clickable links.
 * Handles http/https URLs, mailto: links, and bare email addresses.
 * Preserves line breaks.
 */
export const linkify = (
  text: string,
  linkColor?: string
): React.ReactNode[] => {
  return text.split('\n').map((line, i) => (
    <React.Fragment key={i}>
      {line
        .split(' ')
        .map((word, j) => linkifyWord(word, `${i}-${j}`, linkColor))}
      <br />
    </React.Fragment>
  ));
};
